/*
 * AZUA — Desconto progressivo no CART DRAWER.
 * Aplica no TOTAL exibido a mesma regra do bloco "AS — Desconto Progressivo"
 * (por QUANTIDADE de peças do MESMO produto). Puramente visual/estimativa —
 * o desconto real é aplicado no checkout (Yampi). Mantenha as faixas abaixo
 * IGUAIS às do bloco e às regras do Yampi.
 *
 * Regra atual (template product.json): 2+ peças = 15% off, 4+ peças = 25% off.
 * Dual: no browser dirige o DOM; no Node exporta computeDiscount() p/ teste.
 */
(function (root) {
  'use strict';

  // Faixas por QUANTIDADE do produto (aplica a maior faixa atingida).
  var TIERS = [
    { qty: 4, off: 25 },
    { qty: 2, off: 15 }
  ];

  function offForQty(qty) {
    for (var i = 0; i < TIERS.length; i++) {
      if (qty >= TIERS[i].qty) return TIERS[i].off;
    }
    return 0;
  }

  // cart = objeto do /cart.js. Retorna { base, discounted, discount } em centavos.
  function computeDiscount(cart) {
    var items = (cart && cart.items) || [];
    var qtyByProduct = {};
    items.forEach(function (it) {
      var k = String(it.product_id);
      qtyByProduct[k] = (qtyByProduct[k] || 0) + it.quantity;
    });
    var base = 0, discounted = 0;
    items.forEach(function (it) {
      var lineBase = it.original_line_price != null ? it.original_line_price : (it.price * it.quantity);
      var off = offForQty(qtyByProduct[String(it.product_id)]);
      base += lineBase;
      discounted += Math.round(lineBase * (100 - off) / 100);
    });
    return { base: base, discounted: discounted, discount: base - discounted };
  }

  // ----- Node (teste) -----
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { computeDiscount: computeDiscount, offForQty: offForQty, TIERS: TIERS };
    return;
  }

  // ----- Browser -----
  var doc = root.document;
  if (!doc) return;

  function fmt(cents) {
    try {
      if (root.theme && root.theme.Currency && root.theme.moneyFormat) {
        return root.theme.Currency.formatMoney(cents, root.theme.moneyFormat);
      }
    } catch (e) { /* fallback */ }
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  var busy = false;      // trava reentrância do observer enquanto escrevo o total
  var debounceTimer = null;

  function paint(res) {
    var totals = doc.querySelectorAll('.js-cart-total');
    for (var i = 0; i < totals.length; i++) {
      var el = totals[i];
      // 1) total com desconto
      var target = fmt(res.discounted);
      if (el.textContent.trim() !== target) {
        busy = true;
        el.textContent = target;
        // libera a trava depois do ciclo do observer
        setTimeout(function () { busy = false; }, 0);
      }
      // 2) linha "Desconto progressivo"
      var host = el.closest('.bottom-total, .mini-cart-total') || el.parentNode;
      var anchor = host && host.parentNode ? host : el.parentNode;
      var container = anchor.parentNode;
      var line = container.querySelector('.js-progdisc-line');
      if (res.discount > 0) {
        if (!line) {
          line = doc.createElement('div');
          line.className = 'js-progdisc-line';
          line.style.cssText = 'display:flex;justify-content:space-between;align-items:center;font-size:12px;font-weight:700;color:var(--azua-gold,#c8a84b);margin-bottom:6px;';
          container.insertBefore(line, anchor);
        }
        line.innerHTML = '<span>Desconto progressivo</span><span>-' + fmt(res.discount) + '</span>';
      } else if (line) {
        line.parentNode.removeChild(line);
      }
    }
  }

  function refresh() {
    if (typeof root.fetch !== 'function') return;
    root.fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { paint(computeDiscount(cart)); })
      .catch(function () { /* silencioso */ });
  }

  function schedule() {
    if (busy) return;
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(refresh, 130);
  }

  function boot() {
    if (!doc.querySelector('.js-cart-total')) return;
    refresh();
    if (typeof MutationObserver === 'function') {
      var obs = new MutationObserver(schedule);
      var totals = doc.querySelectorAll('.js-cart-total, .js-cart-items-count');
      for (var i = 0; i < totals.length; i++) {
        obs.observe(totals[i], { childList: true, characterData: true, subtree: true });
      }
    }
    doc.addEventListener('cart:updated', refresh);
    doc.addEventListener('cart:refresh', refresh);
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot);
  else boot();
})(typeof window !== 'undefined' ? window : this);
